<template>
    <a href="#" @click.prevent="showModal">
        <slot></slot>
    </a>
</template>

<script>
import ContactModal from "../modals/ContactModal";

export default {
    props: {
        translations: {
            type: Object,
            required: true
        },

        googleAnalyticsEventLabel: {
            type: String,
            required: false
        },

        sharpspringEndpoint: {
            type: String,
            required: false
        }
    },

    methods: {
        showModal() {
            this.$modal.show(ContactModal, {'translations': this.translations, 'googleAnalyticsEventLabel': this.googleAnalyticsEventLabel, 'sharpspringEndpoint': this.sharpspringEndpoint}, { width: '664', height: 'auto', scrollable: true })
        }
    }
}
</script>